/**
 * 组件 type 策略注册表。
 *
 * 各 types/*.js 在自己文件末尾调 `registerComponentType(strategy)` 注册；
 * orchestrator / outlineRenderer / collision / validate 都从此处取策略对象，
 * 避免循环依赖。
 */

const registry = Object.create(null);

/**
 * 注册一个 type 策略。重复注册以最后一次为准（开发时方便热重载）。
 * @param {Object} strategy - 必须含 .type 字段
 * @returns {void}
 */
export function registerComponentType(strategy) {
  if (!strategy || !strategy.type) {
    throw new Error(
      '[serviceComponentHole] registerComponentType: 缺少 strategy.type'
    );
  }
  registry[strategy.type] = strategy;
}

/**
 * 取一个 type 策略。未注册返回 null。
 * @param {string} type
 * @returns {Object|null}
 */
export function getComponentType(type) {
  return registry[type] || null;
}

/**
 * 拿当前所有已注册的 type 字符串（debug 用）。
 * @returns {string[]}
 */
export function listRegisteredTypes() {
  return Object.keys(registry);
}
